/**
 * Created by Administrator on 2017/5/24.
 */
import Vue from 'vue';

function deal(error, rule, callback, defMsg){
  if(error){
    callback(rule.message||defMsg||"不合法")
  } else {
    callback();
  }
}

function dealRegex(regex, rule, val, callback, defMsg){
  var reg = regex || rule.regex;
  if(rule.emptyAble && (!val || val == '')){
    callback();
  }else if(!reg){
    callback("验证规则错误")
  }else{
    if(typeof reg == "string"){
      reg = new RegExp(reg)
    }
    deal(!reg.test(val), rule, callback, defMsg);
  }
}

var area = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外"}
function dealIdCard(rule, val, callback, defMsg){
  if(val){
    const f=(v, i)=>parseInt(v.substr(i,1))
    if(val.length != 15 && val.length != 18 && val.length != 8){
      return callback(rule.message||defMsg||"不合法1")
    } else if(val.length == 18){
      var a = val.substr(0,2);
      if(!area[parseInt(a)]){
        return callback(rule.message||defMsg||"不合法2")
      }
      var yyyy = val.substr(6, 4), mm = val.substr(10,2), dd = val.substr(12,2);
      var DD = new Date(yyyy  + "/" + mm + "/" + dd);
      if(!(DD.getFullYear() == yyyy && (DD.getMonth() + 1) == mm && DD.getDate() == dd)){
        return callback(rule.message||defMsg||"不合法3");
      }
      var S = (f(val,0) + f(val,10)) * 7 + (f(val,1) + f(val,11)) * 9 + (f(val,2) + f(val,12)) * 10 + (f(val,3) + f(val,13)) * 5
        + (f(val,4) + f(val,14)) * 8 + (f(val,5) + f(val,15)) * 4 + (f(val,6) + f(val,16)) * 2 + f(val,7) * 1 + f(val,8) * 6 + f(val,9) * 3;
      if(val.substr(17,1) !== "10X98765432".substr((S % 11),1)){
        return callback(rule.message||defMsg||"不合法4");
      }
    } else if(val.length == 15){
      var a = val.substr(0,2);
      if(!area[parseInt(a)]){
        return callback(rule.message||defMsg||"不合法5")
      }
      var yy = val.substr(6, 2), mm = val.substr(8,2), dd = val.substr(10,2);
      var DD = new Date("19" + yy  + "/" + mm + "/" + dd);
      if(!(DD.getYear() == yy && (DD.getMonth() + 1) == mm && DD.getDate() == dd)){
        return callback(rule.message||defMsg||"不合法6")
      }
    } else {
      if(!/^[A-Z]\d{6}[A0-9]$/.test(val)){
        return callback(rule.message||defMsg||"不合法7")
      }
      var S=((val.substr(0,1).charCodeAt()-64)*8+f(val,1)*7+f(val,2)*6+f(val,3)*5+f(val,4)*4+f(val,5)*3+f(val,6)*2)%11;
      if(!((S==0 && val.substr(7,1)=='0') || (S==1&&val.substr(7,1)=='A') || (f(val,7)==(11-S)))){
        return callback(rule.message||defMsg||"不合法8")
      }
    }
  }
  callback();
}

Vue.prototype.$validator = {
  required: (rule, val, callback) => { deal(!val || val == "", rule, callback, "不能为空"); },
  maxLength: function (rule, val, callback) {
    var target = rule.maxLength;
    if(!target){
      callback("验证规则错误")
    } else {
      deal(val && val.length > target, rule, callback, "不能超过"+target+"个字符");
    }
  },
  minLength: function (rule, val, callback) {
    var target = rule.minLength;
    if(!target){
      callback("验证规则错误")
    } else {
      deal(val && val.length < target, rule, callback, "不能少于"+target+"个字符");
    }
  },
  lengthRank: function (rule, val, callback) {
    var min = rule.minLength;
    var max = rule.maxLength;
    if(!min || !max){
      callback("验证规则错误")
    } else {
      deal(val && (val.length < min || val.length > max), rule, callback, "输入"+min+"-"+max+"个字符");
    }
  },
  maxValue: function (rule, val, callback) {
    var target = rule.maxValue;
    if(!target){
      callback("验证规则错误")
    } else {
      deal(val && Number(val) > target, rule, callback, "值不能大于"+target);
    }
  },
  minValue: function (rule, val, callback) {
    var target = rule.minValue;
    if(!target){
      callback("验证规则错误")
    } else {
      deal(val && Number(val) < target, rule, callback, "值不能小于"+target);
    }
  },
  valueRank: function (rule, val, callback) {
    var min = rule.minValue;
    var max = rule.maxValue;
    if(!min || !max){
      callback("验证规则错误")
    } else {
      deal(val && (Number(val) < min || Number(val) > max), rule, callback, "输入"+min+"-"+max+"的值");
    }
  },
  regex: (rule, val, callback) => { dealRegex(null, rule, val, callback); },
  idCard: (rule, val, callback) => { dealIdCard(rule, val, callback, "不是合法的身份证号"); },//"不是合法的身份证号"
  certificateNo:(rule, val, callback) => {
    if(/^[A-Z0-9]{12,18}$/.test(val)){
      callback();
    } else {
      dealIdCard(rule, val, callback, "不是合法的证件号")
    }
  },
  specialVal: (rule, val, callback) => { dealRegex(/^[^-`=\\\[\];',.\/~!@#$￥！……%^&*()_+|{}:"<>?\s]*$/, rule, val, callback, "不能包含特殊字符"); },
  businessLicenseVal: (rule, val, callback) => { dealRegex(/^[A-Z0-9]{12,18}$/, rule, val, callback, "不是合法的营业执照号"); },
  bankCard: (rule, val, callback) => { dealRegex(/^[0-9]{16,21}$/, rule, val, callback, "不是合法的银行卡号"); },
  mobile: (rule, val, callback) => { dealRegex(/^1[1-9]\d{9}$/, rule, val, callback, "不是合法的手机号"); },
  email: (rule, val, callback) => { dealRegex(/^[\w.]+@[\w.]{3,}$/, rule, val, callback, "不是合法的邮箱"); },
  password: (rule, val, callback) => { dealRegex(/^(?!\d{6,16}$)[\S]{6,16}$/, rule, val, callback, "不是合法的密码"); },
  number: (rule, val, callback) => { dealRegex(/^[+\-]?\d+(\.\d+)?$/, rule, val, callback, "不是合法的数值"); },
  integer: (rule, val, callback) => { dealRegex(/^\d+$/, rule, val, callback, "不是合法的数字"); },
  mobileOrEmail: (rule, val, callback) => { dealRegex(/^(1[1-9]\d{9})|([\w.]+@[\w.]{3,})$/, rule, val, callback, "不是手机或者邮箱"); },
}



// WEBPACK FOOTER //
// ./src/common/js/common-validator.js